import { Image, Card, Flex } from "antd";

import { SalesTargets } from "users/components";
import actualSalesIcon from "sales/assets/images/actual_sales.svg";
import targetSalesIcon from "sales/assets/images/target_sales.svg";
import newSalesIcon from "sales/assets/images/new_sales.svg";
import {
  SalesByUtility,
  SalesLeaderboard,
  TargetVsActualSales,
} from "sales/components";
import {
  ISalesCards,
  ITargetVsActualSales,
  ISalesByUtility,
  ISalesLeaderboard,
} from "sales/models";
import { utilityService } from "shared/services";
import { StatisticCard } from "shared/components";
import variables from "../../../../../_variables.scss";

type Props = {
  loading?: boolean;
  summaryCards?: ISalesCards;
  targetVsActualSales?: ITargetVsActualSales[];
  salesByUtility?: ISalesByUtility[];
  salesLeaderboard?: ISalesLeaderboard[];
};

export const ProgramManagerDashboardSalesCard = ({
  loading,
  summaryCards,
  targetVsActualSales,
  salesByUtility,
  salesLeaderboard,
}: Props) => {
  return (
    <Card
      loading={loading}
      bordered={false}
      data-testid='programManagerDashboardSalesCard'
    >
      <Flex vertical gap={variables.gap}>
        <h1>Sales</h1>
        <SalesTargets name='sales-targets' />
        <TargetVsActualSales data={targetVsActualSales} />
        <Flex gap={variables.gap}>
          <StatisticCard
            testId='targetSales'
            title='Target Sales'
            value={summaryCards?.targetSales ?? 0}
            prefix='$'
            formatter={utilityService.statisticsFormatter}
            backgroundColor={variables.taupeColor}
            Icon={() => (
              <Image
                src={targetSalesIcon}
                alt='Target Sales Icon'
                preview={false}
                width={35}
              />
            )}
            width={variables.fullWidth}
          />
          <StatisticCard
            testId='actualSales'
            title='Actual Sales'
            value={summaryCards?.actualSales ?? 0}
            prefix='$'
            formatter={utilityService.statisticsFormatter}
            backgroundColor={variables.paleGreenColor}
            Icon={() => (
              <Image
                src={actualSalesIcon}
                alt='Actual Sales Icon'
                preview={false}
                width={35}
              />
            )}
            width={variables.fullWidth}
          />
          <StatisticCard
            testId='totalPipeline'
            title='Total Pipeline'
            value={summaryCards?.newSales ?? 0}
            prefix='$'
            formatter={utilityService.statisticsFormatter}
            backgroundColor={variables.lightBlueColor}
            Icon={() => (
              <Image
                src={newSalesIcon}
                alt='New Sales Icon'
                preview={false}
                width={35}
              />
            )}
            width={variables.fullWidth}
          />
        </Flex>
        <Flex gap={variables.gap}>
          <SalesLeaderboard data={salesLeaderboard} dataLoading={loading} />
          <SalesByUtility data={salesByUtility} height={variables.defaultComponentHeight} />
        </Flex>
      </Flex>
    </Card>
  );
};
